import { Injectable } from '@angular/core';
import { FirebaseApp } from 'angularfire2';
import * as firebase from 'firebase';
import { FirebaseService } from './firebase.service';
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

@Injectable()
export class FirebaseStorageService {
    // private db;
    public storageRootRef;
    // images: FirebaseListObservable<Image[]>;
    // name;
    // url;
    // size;

    constructor(
        // private firebaseService: FirebaseService,
    ) {
        // this.db = firebaseService.db;
        this.storageRootRef = firebase.storage().ref();
        // this.loadImagesdb();

    }

    // imageUpload(selectedFile, uploader, closeBtn, modalTitle) {
    //     let storageRef = this.storageRootRef.child('ingredient/' + selectedFile.name);
    //     // console.log('nama '+ selectedFile.name);
    //     // return storageRef.put(selectedFile).then(function(snapshot) {
    //     // 	console.log('berhasil');
    //     // });

    //     var self = this;

    //     this.getImageSize(selectedFile).then((dimension: number[]) => {
    //         var task = storageRef.put(selectedFile);
    //         task.on('state_changed',
    //             function progress(snapshot) {
    //                 var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    //                 uploader.style.width = percentage + '%';
    //             },

    //             function error(err) {
    //                 console.log('Error bos');
    //             },

    //             function complete() {
    //                 for (var i in closeBtn) {
    //                     if (closeBtn.hasOwnProperty(i)) {
    //                         closeBtn[i].style.display = 'block';
    //                     }
    //                 }
    //                 modalTitle.innerHTML = 'Upload Complete';
    //                 storageRef.getMetadata().then(function (metadata) {
    //                     console.log(metadata);
    //                     var image = new Image();
    //                     image.name = metadata.name;
    //                     image.url = metadata.downloadURLs;
    //                     image.size = metadata.size;
    //                     image.dimension = dimension;

    //                     self.addImage(image);
    //                 });
    //             }
    //         );
    //     })
    // }

    // public getImageSize(file: File) {
    //     var promise = new Promise((resolve, reject) => {
    //         var image = document.createElement('img');
    //         image.onload = () => {
    //             resolve([image.width, image.height]);
    //         }
    //         image.src = URL.createObjectURL(file);

    //         image.remove();
    //     });

    //     return promise;
    // }

    // loadImagesdb() {
    //     window.dispatchEvent(new Event('loading'));
    //     this.images = this.db.list('/images') as FirebaseListObservable<Image[]>
    //     this.images.subscribe(data => {
    //         this.triggerDataChange();
    //     });
    // }

    // triggerDataChange() {
    //     window.dispatchEvent(new Event('data-loaded'));
    // }

    // addImage(image) {
    //     this.images.push(image);
    // }

    // getImages() {
    //     return this.images;
    // }

    // getImageDownloadUrl(name) {
    //     return firebase.storage().ref().child('ingredient/' + name).getDownloadURL();
    // }

    // getImage(name) {
    //     let storageRef = firebase.storage().ref().child('ingredient/' + name);
    //     return storageRef;
    // }

    // deleteImage(name, key) {
    //     var self = this;
    //     // let storageRef = firebase.storage().ref().child('ingredient/'+name);
    //     this.getImage(name).delete().then(function () {
    //         console.log('Berhasil hapus');
    //         var result = self.images.remove(key);
    //         return result;
    //     }).catch(function () {
    //         console.log('uh-oh error');
    //     });
    // }

}

// export class Image {
//     $key?: string;
//     name?: string = '';
//     url?: string[];
//     size?: string = '';
//     dimension?: number[];

//     created_at?: number;
//     updated_at?: number;

//     constructor() {
//         var now = new Date();
//         this.created_at = now.getTime();
//         this.updated_at = now.getTime();
//     }
// }


// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/firebase-storage.service.ts